import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { DraftBadge } from './DraftBadge';
import { SeverityBadge } from './SeverityBadge';

interface CarePlanItem {
  title?: string;
  status?: string;
  summary?: string;
  activities?: string[];
  target_date?: string;
}

export function CarePlanCard({ item }: { item: CarePlanItem }) {
  // #115: response-body collapsibles start closed by default.
  const [open, setOpen] = useState(false);
  const activities = item.activities ?? [];

  return (
    <div className="rounded-lg border border-border bg-surface-raised overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-surface-sunken/30 transition-colors"
        aria-expanded={open}
      >
        {open ? (
          <ChevronDown className="w-4 h-4 text-text-tertiary" />
        ) : (
          <ChevronRight className="w-4 h-4 text-text-tertiary" />
        )}
        <span className="font-medium text-foreground flex-1">
          {item.title ?? 'Care Plan'}
        </span>
        {/* NEW-11: care-plan cards present agent-generated advisory content —
            keep that unmissable next to the status. */}
        <DraftBadge />
        {item.status && (
          <SeverityBadge value={item.status} fallback="normal" />
        )}
      </button>
      {open && (
        <div className="px-4 pb-4 pt-1 border-t border-border">
          {item.summary && (
            <p className="text-sm text-text-tertiary mb-3">{item.summary}</p>
          )}
          {activities.length > 0 && (
            <div>
              <h5 className="text-xs font-medium text-text-tertiary mb-2 uppercase tracking-wide">
                Activities
              </h5>
              <ul className="list-disc list-inside space-y-1 text-sm text-foreground">
                {activities.map((a, i) => (
                  <li key={i}>{a}</li>
                ))}
              </ul>
            </div>
          )}
          {item.target_date && (
            <p className="text-xs text-text-tertiary mt-3">
              Target: {item.target_date}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
